<template>
  <div v-if="!isLoaded" class="d-flex justify-content-center">
    <div class="spinner-border" role="status" />
  </div>
  <div v-else>
    <SliderShow v-if="slideshow !== null && slideshow.length > 0" :slide-show="slideshow" />
    <div class="page-container mx-xl-auto mx-4 gap-4 d-flex flex-column">
      <Breadcrumb :elements="formattedBreadcrumbElements" />
      <h1 class="my-4 d-flex justify-content-center text-center" v-text="title" />
      <text-and-widget-display :text-body="content" />
      <SliderList
        v-if="recommendedPlaces.length > 0"
        :list-title="$t('featured_places.list.title')"
        :items="recommendedPlaces"
      >
        <template #card="data">
          <PlaceCard :item="data.item" />
        </template>
      </SliderList>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue'
import PageName from '@/constants/pageName'
import SliderShow from '@/components/slider-show/SliderShow.vue'
import SliderList from '@/components/slider-list/SliderList.vue'
import PlaceCard from '@/components/place-card/PlaceCard.vue'
import TextAndWidgetDisplay from '@/components/text-and-widget-display/TextAndWidgetDisplay.vue'
import { useApiErrorHandler } from '@/components/api-error-handler/ApiErrorHandler.js'

export default {
  name: 'ContentPage',
  components: {
    TextAndWidgetDisplay,
    PlaceCard,
    SliderList,
    Breadcrumb,
    SliderShow,
  },
  beforeRouteUpdate(to, from, next) {
    this.getStaticContent(to.params.title)
    next()
  },
  setup() {
    return { ...useApiErrorHandler() }
  },
  data() {
    return {
      /**
       * Statikus oldal tartalom
       *
       * @type {string|null}
       */
      content: null,
      /**
       * Betöltött-e a statikus tartalom
       *
       * @type {boolean}
       */
      isLoaded: false,
      /**
       * Statikus oldal címe
       *
       * @type {string|null}
       */
      title: null,
      /**
       * Slideshow slideokat listája.
       *
       * @type {{
       *  slides: {
       *    name: string,
       *    desc: string,
       *    altTag: string,
       *    url: string,
       *    imageSrc: string,
       *  }[],
       * }|null}
       */
      slideshow: null,
      /**
       * Kapcsolódó helyszinek
       *
       * @type {array}
       */
      recommendedPlaces: [],
    }
  },
  /**
   * meta adatok beállítása.
   * @return {{title: string}}
   */
  head() {
    return {
      title: this.getTitle,
    }
  },
  computed: {
    /**
     * Cim meghatározása, amelyből meta title lesz.
     * @return {string}
     */
    getTitle() {
      return this.title
    },
    /**
     * Formázott breadcrumb elemek.
     */
    formattedBreadcrumbElements() {
      const ret = []

      ret.push({
        title: this.$t('breadcrumb.main_page.title'),
        name: PageName.HOME,
      })

      ret.push({
        title: this.title,
      })

      return ret
    },
  },
  beforeMount() {
    const title = this.$route.params.title

    this.getStaticContent(title)
  },
  methods: {
    getStaticContent(title) {
      return Axios.post('/api/public/content/getStaticPageContent', {
        title: title,
      })
        .then(({ data }) => {
          this.content = data.content
          this.title = data.title
          this.slideshow = data.slideshow
          this.recommendedPlaces = data.recommendedPlaces
        })
        .catch(error => {
          this.apiNotFoundHandler(error, this.$router, this.$route)
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
  },
}

</script>
<style lang="scss" scoped>
.page-container {
  max-width: 80rem;
}
</style>
